<template>
	<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/jianjie' }">集团简介设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加集团荣誉</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="150px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="权重">
					<el-input v-model="formData.weights" style="width: 70px;" type="number"></el-input>
					<el-tag style="margin-left: 20px;" type="danger">权重越高，排序越靠前</el-tag><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="集团荣誉封面">
					<!-- <el-input v-model="formData.picUrl"></el-input> -->
					<!-- v-model="formLabelAlign.name" -->
					<!-- <img :src="$imgTitle+formData.picUrl" /> -->
					<el-upload class="upload-demo" list-type="picture" :action="uploadUrl" :limit="1" :file-list="fileList" :on-remove="onRemove"
					 :on-success="onSuccess">
						<el-button size="small" type="primary">点击上传图片</el-button><!-- <el-tag style="margin-left: 20px;" type="danger">点击上传文章封面图</el-tag> -->
					</el-upload>
				</el-form-item>
				<el-form-item label="集团荣誉标题">
					<el-input v-model="formData.title"></el-input>
				</el-form-item>
				<el-form-item label="集团荣誉简介">
					<el-input v-model="formData.introduction"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="集团荣誉详情">
					<el-tag style="margin-left: 20px;" type="danger">请在详情中一并写上标题</el-tag>
					<el-upload class="avatar-uploader" :action="uploadUrl" type="drag" :show-file-list="false" :on-success="uploadSuccess">
					</el-upload>
					<quill-editor v-model="quillData" :options="editorOption" ref="myref"></quill-editor>
				</el-form-item>
			</el-form>
			
			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>


		<div :visible.sync="videoUploadTag">
			<el-dialog width="50%" id="video_upload" style="margin-top: 1px" title="填写视频连接" :visible.sync="videoUploadTag"
			 append-to-body>
				
				<el-form label-width="80px" :model="formData">
					<el-form-item label="视频连接">
						<el-input v-model="videoLink"></el-input><!-- v-model="formLabelAlign.type" -->
					</el-form-item>
				</el-form>
				<el-button type="primary"  style="margin: 20px 0px 0px 80px " @click="addVideoLink()">添加
				</el-button>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		['blockquote', 'code-block'],

		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // superscript/subscript
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction

		[{
			'size': ['12px', '14px', false, '18px', '22px', '26px', '30px', '36px', '42px']//['small', false, 'large', 'huge']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],

		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image', 'video'],
		['clean'] // remove formatting button
	]
	import {
		quillRedefine
	} from 'vue-quill-editor-upload' //引入图片上传
	
	
	import ImageResize from 'quill-image-resize-module' 
	Quill.register('modules/imageResize', ImageResize) 
	
	export default {
		components: {

		},
		data() {
			var self2 = this;
			return {
				//显示插入视频链接弹框的标识
				videoUploadTag: false,
				//弹框插入的视频链接记录
				videoLink: "",
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				/* fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}], */
				fileList: [],
				fileList2: [],
				id: '',
				detailData: {},
				quillData: '',
				formData: {
					picUrl: '',
					title: '',
					quillData: '',
					introduction: '',
					weights: ''
				},

				editorOption: {
					theme: 'snow', // or 'bubble'
					modules: {
						imageResize: { //放大缩小
							displaySize: true
						},
						toolbar: {
							container: toolbarOptions, // 工具栏
							handlers: {
								'image': function(value) {
									if (value) {
										// 触发input框选择图片文件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								},
								'video': function(value) {
									self2.videoUploadTag = true;
								}
							}
						}
					}
				},

			}
		},
		created() {
			var that = this
			setTimeout(function() {
				console.log(that.$refs.myref.quill)
			}, 100)

		},
		methods: {
			 addVideoLink() {
			        if (this.videoLink.length == 0) {
			         return this.$message.error('请输入视频链接！');
			        }
			        //当编辑器中没有输入文本时，这里获取到的 range 为 null
			        var range = this.$refs.myref.quill.getSelection();
			        //视频插入在富文本中的位置
			        var index = 0;
			        if (range == null) {
			          index = 0;
			        } else {
			          index = range.index;
			        }
			        //隐藏弹框
			        this.videoUploadTag = false;
			        //将视频链接插入到当前的富文本当中
			        this.$refs.myref.quill.insertEmbed(index, 'video', this.videoLink);
			      },
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = [];
			},
			onSuccess(res) {
				console.log('res=' + JSON.stringify(res))
				this.fileList2.push(res)
			},
			handleSuccess(res) {

				// 获取富文本组件实例
				let quill = this.$refs.QuillEditor.quill
				// 如果上传成功
				if (res) {
					// 获取光标所在位置
					let length = quill.getSelection().index;
					// 插入图片，res为服务器返回的图片链接地址
					quill.insertEmbed(length, 'image', res)
					// 调整光标到最后
					quill.setSelection(length + 1)
				} else {
					// 提示信息，需引入Message
					Message.error('图片插入失败')
				}
			},
			uploadSuccess(res, file) { // res为图片服务器返回的数据
				var that = this
				console.log('uploadSuccess res=' + JSON.stringify(res))
				setTimeout(function() {
					console.log("194=" + that.$refs.myref)
					let quill = that.$refs.myref.quill;

					if (res) {
						let length = quill.getSelection().index; // 获取光标所在位置
						quill.insertEmbed(length, 'image', that.$imgTitle + res); // 插入图片  res.info为服务器返回的图片地址
						quill.setSelection(length + 1); // 调整光标到最后
					} else {
						that.$message.error('图片插入失败')
					}
					that.quillUpdateImg = false; // loading动画消失
				}, 0)

			},
			async getDetailData() {
				const res = await this.$http.get('/v1/official/news/activity/detail', {
					params: {
						id: this.id
					}
				})
				console.log(JSON.stringify(res))
				if (res.data.code == 0) {
					this.detailData = res.data.data;
					this.formData.picUrl = this.detailData.coverPicture;
					this.formData.title = this.detailData.title;
					this.formData.introduction = this.detailData.introduction
					this.formData.quillData = this.detailData.content;
					var obj = {};
					obj.name = '原来文章封面图'
					obj.url = this.$imgTitle + this.detailData.coverPicture;
					this.fileList.push(obj)
				}
			},
			async submit() {
				//console.log(this.quillData)
				var obj = {};
				obj['title'] = this.formData.title
				obj['introduction'] = this.formData.introduction
				obj['ftext'] = this.quillData
				obj['weights'] = +this.formData.weights
				obj['coverPicture'] = this.fileList2.join(',')
				

				console.log(JSON.stringify(obj))
				
				
				if (obj.weights == '') {
					return this.$message.error('请添加权重!')
				}
				if (obj.title == '') {
					return this.$message.error('请添加标题!')
				}
				if (obj.introduction == '') {
					return this.$message.error('请添加简介!')
				}
				if (obj.ftext == "") {
					return this.$message.error('请添加详情!')
				}
				if (obj.coverPicture == "") {
					return this.$message.error('请添加封面图!')
				}
				
				/* 新增集团荣誉/v1/official/manag/honor/add post请求 参数 String introduction（简介），Integer weights（权重），String coverPicture（封面图） */
				const res = await this.$http.post('/v1/official/manag/honor/add', {
					request: obj
				})
				console.log('res=' + JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('添加成功')
					this.$router.push({
						path: '/jianjie'
					})
				} else {
					this.$message.error(res.data.message)
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.el-card {
		/* width: 1000px; */
	}

	.submitBtn {
		margin: 0 auto;
		margin-top: 90px;
		margin-left: 150px;
	}
</style>
